var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFoundView"},[_c('strong',[_vm._v("NotFoundView.vue")]),_c('hr'),_c('h1',[_vm._v("404 for url \""+_vm._s(_vm.currentUrl)+"\"")])])}
var staticRenderFns = []

export { render, staticRenderFns }